<template>
  <div class="index">
    <el-container style="width: 100%">
      <!-- 左侧菜单 -->
      <v-aside :style="collapse ? 'width: 60px;' : 'width:auto'"></v-aside>
      <!-- 右侧内容  :style="collapse?'position: relative; padding-left: 60px;':(this.$i18n.locale == 'en_US' ? 'position: relative; padding-left: 200px' : (this.$i18n.locale == 'ja_JP' ? 'position: relative; padding-left: 263px' : 'position: relative; padding-left: 182px'))"-->
      <el-container style="width: 100%; display: flow-root; position: relative">
        <!-- 右侧内容-头部导航 -->
        <v-header v-on:password="password"></v-header>
        <!-- 右侧内容-头部Tab导航 -->
        <transition name="tags" mode="out-in">
          <v-tags v-show="tagsTop"></v-tags>
        </transition>
        <!-- 右侧内容-密码修改组件 -->
        <v-password :dialogPassword="dialogPassword" v-on:closePasswordDialog="passwordDialog"></v-password>
        <!-- 右侧内容-主内容 -->
        <el-main :style="`height: calc(${windowHeight}vh - 110px);`">
          <div
            style="
              width: 100%;
              height: 100%;
              overflow-y: scroll;
              display: flow-root;
              background-color: white;
              border-radius: 5px;
            "
          >
            <vue-scroll style="border-radius: 10px">
              <transition name="move-main" mode="out-in">
                <keep-alive :include="tagList">
                  <router-view></router-view>
                </keep-alive>
              </transition>
            </vue-scroll>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import vPassword from "@/components/Password";
  import vTags from "@/components/Tags";
  import vAside from "@/components/sidebar/Aside";
  import vHeader from "@/components/Header";
  export default {
    name: "Index",
    data() {
      return {
        dialogPassword: false,
        tag: true,
        windowHeight: "100" //实时屏幕高度
      };
    },
    components: {
      vPassword,
      vTags,
      vAside,
      vHeader
    },
    mounted() {
      const that = this;
      window.onresize = () => {
        if (document.body.clientWidth <= 1200) {
          that.$store.dispatch("collapse", true);
        } else {
          that.$store.dispatch("collapse", false);
        }
      };
    },
    methods: {
      passwordDialog(password) {
        this.dialogPassword = password;
      },
      password(password) {
        this.dialogPassword = password;
      }
    },
    computed: {
      collapse() {
        return this.$store.state.collapse;
      },
      tagList() {
        return this.$store.state.tagList;
      },
      tagsTop() {
        return this.$store.state.tagsTop;
      }
    },
    created() {
      if (!this.$store.state.menuList || this.$store.state.menuList.length <= 0) {
        this.$router.push("/login");
      }
      if (this.$route.path === "" || this.$route.path === "/") {
        this.$router.push("/main");
      }
      if (document.body.clientWidth <= 1200) {
        this.$store.dispatch("collapse", true);
      }
    }
  };
</script>

<style lang="scss">
  @import "../assets/scss/index";

  .move-main-enter-active,
  .move-main-leave-active {
    transition: all 0.5s;
  }

  .move-main-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .move-main-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .tags-enter-active,
  .tags-leave-active {
    transition: all 0.5s;
  }

  .tags-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .tags-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .__view {
    width: 100% !important;
  }
  .index {
    display: flow-root;
    width: 100%;
    height: 100%;
  }
  .sys-header {
    position: absolute;
    width: 100%;
    height: 60px;
    display: flow-root;
  }
  .rights {
    display: flow-root;
    width: 90%;
  }
</style>
